import { render, staticRenderFns } from "./build-subject.view.vue?vue&type=template&id=39237d5f&"
import script from "./build-subject.view.ts?vue&type=script&lang=js&"
export * from "./build-subject.view.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports